// This import loads the firebase namespace along with all its type information.
import TrimmedMedia from './trimmed-media-model'

export async function load_trimmedMedias(): Promise<TrimmedMedia[]> {
  throw 'Not implemented'
}

export async function delete_trimmedMedia(): Promise<boolean> {
  throw 'Not implemented'
}

export async function store_trimmedMedia(): Promise<TrimmedMedia> {
  throw 'Not implemented'
}
